import { AuthAction, AuthActionType } from './authAction';

export interface ModalState {
  isOpen: boolean;
  mode: string | null;
  currentPage?: string;
  modalOpened?: boolean;
  isLoading: boolean;
  error: any;
  email: string;
  password: string;
  code: string;
  signInError: null;
  isAuthenticated: boolean;
  user: { email: string } | null;
  token: null;
}

const initialState: ModalState = {
  isOpen: false,
  mode: 'chooser',
  isLoading: false,
  error: null,
  email: '',
  password: '',
  code: '',
  signInError: null,
  isAuthenticated: false,
  user: null,
  token: null,
};

export const modalReducer = (state: ModalState = initialState, action: AuthAction): ModalState => {
  switch (action.type) {
    case AuthActionType.OPEN_MODALWINDOW:
      return {
        ...state,
        isOpen: true,
        mode: 'main',
      };

    case AuthActionType.OPEN_REGISTRATION:
      return {
        ...state,
        isOpen: true,
        mode: 'registration',
      };
    case AuthActionType.SIGNIN_MODAL:
      return {
        ...state,
        isOpen: true,
        mode: 'regis.Modal',
      };
    case AuthActionType.CLOSE_MODAL:
      return {
        ...state,
        isOpen: false,
      };
    case AuthActionType.OPEN_MAIlCONFIRMATION:
      return {
        ...state,
        isOpen: true,
        mode: 'MailConfirmation',
      };
    case AuthActionType.OPEN_FIO:
      return {
        ...state,
        isOpen: true,
        mode: 'fio',
      };
    case AuthActionType.OPEN_CREATEPASSWORD:
      return {
        ...state,
        isOpen: true,
        mode: 'password',
      };
    case AuthActionType.SIGN_UP_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case AuthActionType.SIGN_UP_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: null,
        mode: 'confirmation',
      };
    case AuthActionType.SIGN_UP_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
        email: action.payload.email,
        password: action.payload.password,
      };
    case AuthActionType.ON_CHANGE_EMAIL:
      return {
        ...state,
        email: action.payload.email,
      };
    case AuthActionType.ON_CHANGE_PASSWORD:
      return {
        ...state,
        password: action.payload.password,
      };
    case AuthActionType.FORGOT_PASSWORD_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case AuthActionType.FORGOT_PASSWORD_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: null,
      };
    case AuthActionType.FORGOT_PASSWORD_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
        email: action.payload.email,
      };
    case AuthActionType.CONFIRM_PASSWORD_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case AuthActionType.CONFIRM_PASSWORD_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
        email: action.payload.email,
        password: action.payload.password,
        code: action.payload.code,
      };
    case AuthActionType.CONFIRM_PASSWORD_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: null,
        mode: null,
        isOpen: false,
        isAuthenticated: true,
      };
    case AuthActionType.ON_CHANGE_CODE:
      return {
        ...state,
        code: action.payload.code,
      };
    case AuthActionType.SIGN_UP_CONFIRM_CODE_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
        email: action.payload.email,
        code: action.payload.code,
      };
    case AuthActionType.SIGN_UP_CONFIRM_CODE_FAIL:
      return {
        ...state,
        error: action.payload,
        isLoading: false,
      };
    case AuthActionType.SIGN_UP_CONFIRM_CODE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: null,
        mode: 'fio',
      };
    case AuthActionType.SIGN_IN_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case AuthActionType.SIGN_IN_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: null,
        mode: null,
        isOpen: false,
        isAuthenticated: true,
      };
    case AuthActionType.SIGN_IN_REQUEST:
      return {
        ...state,
        user: {
          email: action.payload.email,
        },
        signInError: null,
        isLoading: false,
      };
    case AuthActionType.OPEN_FORGOT_PASSWORD_MODAL:
      return {
        ...state,
        isOpen: true,
        mode: 'forgot.password',
        email: action.payload.email,
      };
    case AuthActionType.CHECK_EMAIL_FORGOT_MODAL:
      return {
        ...state,
        isOpen: true,
        mode: 'check.forgot',
      };
    case AuthActionType.RESET_SIGN_IN_ERROR:
      return {
        ...state,
        signInError: null,
      };
    case AuthActionType.PASSWORD_CONFIRMATION:
      return {
        ...state,
        isOpen: true,
        mode: 'passCon',
      };
    case AuthActionType.SIGN_OUT_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };

    case AuthActionType.SIGN_OUT_SUCCESS:
      return {
        ...state,
        user: null,
        isAuthenticated: false,
        isLoading: false,
        error: null,
      };

    case AuthActionType.SIGN_OUT_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};
